<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/parameters"></back-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h4><u>Αργίες</u></h4>
        </div>
      </div>
      <div class="col-md-1" style>
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>

    <div class="grid-pad">
      <DxDataGrid
        @initialized="saveGridInstance"
        :data-source="holidays"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-borders="true"
        key-expr="Id"
        @row-inserting="onRowInserting"
        @row-updating="onRowUpdating"
        @init-new-row="onInitNewRow"
        @row-removing="onRowRemoving"
        :show-row-lines="true"
        :row-alternation-enabled="true"
      >
        <DxPaging :page-size="20" />
        <DxEditing
          :allow-updating="true"
          :allow-adding="true"
          mode="cell"
          :allow-deleting="true"
          :use-icons="true"
        />
        <DxHeaderFilter :visible="true" />
        <DxFilterRow :visible="true" />
        <DxSearchPanel :visible="true" />

        <DxColumn
          caption="Κωδικός"
          data-field="Id"
          data-type="integer"
          :visible="false"
        >
        </DxColumn>

        <DxColumn
          caption="Περιγραφή"
          data-field="Description"
          data-type="string"
          alignment="left"
        >
          <DxRequiredRule message="Η περιγραφή είναι υποχρεωτική" />
        </DxColumn>
        <DxColumn
          caption="Παρατηρήσεις"
          data-field="Notes"
          data-type="string"
          alignment="left"
        >
        </DxColumn>
        <DxColumn
          caption="Ημερομηνία"
          data-field="Date"
          data-type="date"
          :visible="true"
          alignment="center"
          format="dd/MM/yyyy"
        >
          <DxRequiredRule message="Η Ημερομηνία είναι υποχρεωτική" />
        </DxColumn>

        <DxColumn
          caption="Ενεργός"
          data-field="IsActive"
          data-type="boolean"
          width="150px"
          alignment="center"
        >
        </DxColumn>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import mainService from "../../services/mainService";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxEditing,
  DxPaging,
  DxRequiredRule,
  DxFilterRow,
  DxSearchPanel,
} from "devextreme-vue/data-grid";
import notify from "devextreme/ui/notify";
import BackButton from "../../components/shared/backButton";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";
import { dateWithoutTime } from "../shared/dateHelpers";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxRequiredRule,
    DxFilterRow,
    DxSearchPanel,
    BackButton,
    DxLoadIndicator,
  },
  data() {
    return {
      holidays: [],
      dataGridInstance: null,
      loadIndicatorVisible: false,
    };
  },
  methods: {
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },

    onInitNewRow(e) {
      e.data.IsActive = true;
      e.data.Id = 0;
    },
    async onRowInserting(e) {
      if (e.data.Date != null) e.data.Date = dateWithoutTime(e.data.Date);

      var holiday = e.data;
      holiday.Id = e.data.Id;

      try {
        const res = await mainService.post("/Holidays/AddHoliday", holiday);
        if (res.status != 200) {
          e.cancel = true;
        }
        if (res.data.Message && res.data.Message != "") {
          e.cancel = true;
          notify(res.data.Message, "error", 5000);
        } else {
          this.holidays = this.holidays.map((item) => {
            if (item.Id == 0) {
              item.Id = res.data.Id;
            }
            notify("Η εγγραφή εισήχθει επιτυχώς", "success", 1000);
            return item;
          });
        }
      } catch (error) {
        e.cancel = true;
      }

      this.getHolidays();
    },
    async onRowUpdating(e) {
      //fix strange behaviour of devexpress datepicker
      if (e.newData.Date != null)
        e.newData.Date = dateWithoutTime(e.newData.Date);

      var arr = Object.keys(e.newData);

      var holiday = Object.assign(e.oldData, e.newData);
      holiday.Id = e.key;

      try {
        const res = await mainService.post("/Holidays/UpdateHoliday", holiday);
        if (res.status != 200) {
          e.cancel = true;
        }
        notify("Η αποθήκευση πέτυχε", "success", 1000);
      } catch (error) {
        e.cancel = true;
      }
    },
    async onRowRemoving(e) {
      var _res = await mainService.delete(
        `/Holidays/DeleteHoliday?id=${e.data.Id}`
      );
      if (_res.data != true) {
        notify("Πρόβλημα κατά την Διαγραφή", "error", 1000);
      }
      this.getHolidays();
    },
    async getHolidays() {
      const res = await mainService.get(
        "/Holidays/GetAllHolidays?onlyActive=false"
      );
      this.holidays = res.data;
    },
  },
  computed: {},
  watch: {},

  async mounted() {
    this.loadIndicatorVisible = true;
    this.getHolidays();
    this.loadIndicatorVisible = false;
  },
};
</script>

  <style scoped>
.dx-overlay-wrapper {
  max-width: 100px !important;
}

.dx-toast-message {
  width: 100px !important;
}
</style>